import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PwaInstallService {
  private deferredPromptSubject = new Subject<any>();
  public deferredPrompt$: Observable<any> = this.deferredPromptSubject.asObservable();
  private deferredPrompt: any = null;

  constructor() {
    // Captura o evento antes de qualquer componente estar pronto
    this.setupBeforeInstallPrompt();
  }

  private setupBeforeInstallPrompt() {
    // Verifica se já existe um deferredPrompt armazenado
    if ((window as any).deferredPrompt) {
      this.deferredPrompt = (window as any).deferredPrompt;
      this.deferredPromptSubject.next(this.deferredPrompt);
    }

    window.addEventListener('beforeinstallprompt', (e: Event) => {
      console.log('[PwaInstallService] beforeinstallprompt event captured');
      // Previne o prompt padrão do browser
      e.preventDefault();
      // Guarda o evento
      this.deferredPrompt = e;
      (window as any).deferredPrompt = e;
      // Notifica os subscribers
      this.deferredPromptSubject.next(e);
    });

    window.addEventListener('appinstalled', () => {
      console.log('[PwaInstallService] App installed');
      this.deferredPrompt = null;
      (window as any).deferredPrompt = null;
      this.deferredPromptSubject.next(null);
    });
  }

  getDeferredPrompt(): any {
    return this.deferredPrompt || (window as any).deferredPrompt;
  }

  async promptInstall(): Promise<boolean> {
    const prompt = this.getDeferredPrompt();
    if (!prompt) {
      return false;
    }

    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    
    if (outcome === 'accepted') {
      this.deferredPrompt = null;
      (window as any).deferredPrompt = null;
      this.deferredPromptSubject.next(null);
      return true;
    }
    
    return false;
  }
}
